import {request} from "../../base/HTTP";
import HttpMethod from "../../constants/HttpMethod";

export async function getArrangedPlotRents(data) {
    return await request('/api/arrangedplotrent/search', data);
}

export async function addArrangedPlotRent(data, cid) {
    return await request('/api/arrangedplotrent/' + cid, data, HttpMethod.POST);
}

export function getArrangedPlotRentById(id, userId, companyId) {
    return  request("api/arrangedplotrent/" + id , {userId: userId, companyId: companyId}, HttpMethod.GET);
}

export async function editArrangedPlotRent(data) {
    return await request("api/arrangedplotrent/" + data.id, data, HttpMethod.PUT);
}

export async function deleteArrangedPlotRent(id, uid) {
    return await request('/api/arrangedplotrent/' + id + '/' + uid, {} , HttpMethod.DELETE);
}

export async function stornoArrangedPlotRent(id, uid) {
    return await request('/api/arrangedplotrent/cancel/' + id + '/' + uid, {} , HttpMethod.PUT);
}

export async function undoStornoArrangedPlotRent(id, uid) {
    return await request('/api/arrangedplotrent/undoCancel/' + id + '/' + uid, {} , HttpMethod.PUT);
}

export async function getDeletedOArrangedPlotRents(data) {
    return await request('/api/arrangedplotrent/deleted', data);
}

export async function restoreArrangedPlotRent(data) {
    return await request("api/arrangedplotrent/restore/" + data.id, data, HttpMethod.PUT);
}